import * as React from 'react';

export const SwatchCheck = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 14 14" fill="none" {...props}>
      <g clipPath="url(#prefix__clip0_2062_7223)">
        <path d="M0 0h10c2.352 0 4 1.486 4 4v10c0-2-1.5-3-4-3H8.677C5.542 11 3 8.283 3 4.931V3.5C3 1.5 2 0 0 0z" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.724 3.587c.104.114.1.295-.007.404L8.345 7.42a.261.261 0 01-.376 0L6.283 5.706a.297.297 0 01-.007-.404.261.261 0 01.383-.008l1.498 1.523 3.184-3.237a.261.261 0 01.383.007z"
          fill="#fff"
          stroke="#fff"
          strokeWidth={0.286}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_2062_7223">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
